export default "__VITE_ASSET__JOyvvJha__"